let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cYWWR"), load("h2HOI")]).then(() => parcelRequire('2hWDW'));